import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { EffectCoverflow, Navigation, Pagination } from 'swiper/modules';

export default class Carousel3d {
    constructor() {
        this.slider = document.querySelector('.components-carousel-3d .swiper--3d-carousel');
        this.navigationPrev = document.querySelector('.slider-button-prev--3d-carousel');
        this.navigationNext = document.querySelector('.slider-button-next--3d-carousel');
        this.pagination = document.querySelector('.swiper-pagination--3d-carousel');

        this.ready();
    }

    ready() {
        new Swiper(this.slider, {
            modules: [EffectCoverflow, Navigation, Pagination],
            effect: 'coverflow',
            grabCursor: true,
            centeredSlides: true,
            slidesPerView: 'auto',
            initialSlide: 1,
            coverflowEffect: {
                rotate: 10, 
                stretch: 0,
                depth: 300,
                modifier: 1,
                slideShadows: true,
            },
            navigation: {
                nextEl: this.navigationNext,
                prevEl: this.navigationPrev,
            },
            breakpoints: {
                // Mobile
                480: {
                    slidesPerView: 1,
                    effect: 'slide',
                    spaceBetween: 26,
                    coverflowEffect: {
                        rotate: 0,
                        stretch: 0,
                        depth: 200,
                        modifier: 1,
                        slideShadows: true,
                    },
                },
                // Tablet
                768: {
                    slidesPerView: 2,
                    effect: 'slide',
                    spaceBetween: 26,
                    coverflowEffect: {
                        rotate: 0,
                        stretch: 0,
                        depth: 200,
                        modifier: 1,
                        slideShadows: true,
                    },
                },
                // Desktop
                1024: {
                    slidesPerView: 3,
                    effect: 'coverflow',
                    coverflowEffect: {
                        rotate: 10,
                        stretch: 0,
                        depth: 300,
                        modifier: 1,
                        slideShadows: true,
                    },
                },
            },
        });
    }
}

if (document.querySelector('.components-carousel-3d .swiper--3d-carousel')) {
    new Carousel3d();
}